import React from 'react';
import {connect} from 'react-redux';
import './DescriptionBlock.css';
import Camera from "../Camera/Camera";
// import BarcodeDecoder from "../../utils/BarcodeDecoder";
import scanIcon from "./../../resouces/scan-icon.svg"
import textIconActive from "./../../resouces/text-icon-active.svg"
import textIconNotActive from "./../../resouces/text-icon-not-active.svg"
import ObjectData from "../../dataModel/ObjectData";
import AudioManager from "../../managers/AudioManager";
import {Swipeable} from 'react-swipeable'
import StoreManager from "../../managers/StoreManager";
// import {MediaList} from "../ContentBlock/MediaList";


class DescriptionBlock extends React.Component {

    static instance;

    componentDidMount() {
        DescriptionBlock.instance = this;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // Exit from text mode if next media node don't has a text.
        if (this.props.parameters.textMode && !AudioManager.currentMediaNodeText) {
            this.onSwipe(true);
        }
    }

    state = {
        isCameraActive: false,
        testImg: ""
    };

    parameters = {
        textMode: false,
        currentAvatarId: null,
    };

    decoder = null;

    renderAvatarElement() {
        const {object, isPlaying} = this.props;
        if (!object || !object.avatarImage) return <React.Fragment/>;

        let imageData = object.avatarImage;

        if (isPlaying && AudioManager.lastPlayedSpeek && AudioManager.lastPlayedSpeek.avatarId && AudioManager.lastPlayedSpeek.avatarData) {
            imageData = AudioManager.lastPlayedSpeek.avatarData;
        }

        if (this.props.parameters.currentAvatarId) {
            imageData = object.mediaEntries.find(it => it.mediaId === this.props.parameters.currentAvatarId).fileData;
            console.log("AVATAR FROM SLIDER", this.props.parameters.currentAvatarId);
        }

        return (
            <div id="AvatarContainer">
                <img src={'data:image/jpeg;base64,' + imageData}
                     className='ObjectAvatar'
                     alt=''/>
            </div>
        )
    }

    get currentMediaNodeText() {
        const speakNode = AudioManager.currentSpeakNode;

        if (speakNode) {
            const textList = speakNode
                .map(s => s.textData || null)
                .filter(t => !!t);

            if (textList.length > 0) {
                return  textList.join("\n\n");
            }
        }

        return null;
    }

    renderTextPreview(_text) {
        const {object, selectedLanguage} = this.props;
        if (!object || !this.props.parameters.textMode) return null;

        let textList = _text;
        const objectDescription = object.description(AudioManager.lastPlayedSpeek ? AudioManager.lastPlayedSpeek.language : selectedLanguage);
        if (textList && textList[0] && (textList[0] === objectDescription || objectDescription.includes(textList[0]))) {
            textList.shift();
        }

        const text = textList.join("\n\n");

        return (
            <div id="AvatarContainer">
                <div className="MediaTextBlock">
                    {
                        objectDescription &&
                            <h3 className="heavyText">
                                {objectDescription}
                            </h3>
                    }

                    {text}
                </div>

                <div className="MediaTextGradient" />
            </div>
        )
    }

    get currentAvatarId() {
        const {object, isPlaying} = this.props;
        if (!object || !object.avatarImage) return null;

        const avatarList = object.avatarList;

        if (!this.props.parameters.currentAvatarId && isPlaying && AudioManager.lastPlayedSpeek && AudioManager.lastPlayedSpeek.avatarId) {
            return AudioManager.lastPlayedSpeek.avatarId;
        }

        return (this.props.parameters.currentAvatarId || avatarList[0].mediaId);
    }

    renderSliderControl() {
        const {object} = this.props;
        if (!object || !object.avatarImage) return null;

        const avatarList = object.avatarList;

        return (
            <div className='SliderControlBlock'>

                {
                    AudioManager.currentMediaNodeText &&
                        <img src={this.props.parameters.textMode ? textIconActive : textIconNotActive} alt="" />
                }

                {
                    avatarList.map(it => {
                       return <i key={"SlideControl_" + it.mediaId}
                                 className={`${it.mediaId === this.currentAvatarId && !this.props.parameters.textMode ? "fas" : "far"} 
                                 fa-circle ${!this.props.parameters.textMode && "white"}`} />
                    })
                }

            </div>
        )
    }

    onSwipe(next = true) {
        const {object} = this.props;
        if (!object || !object.avatarImage) return null;

        const avatarList = object.avatarList;

        const curPosition = this.currentAvatarId
            ? avatarList.findIndex(it => it.mediaId === this.currentAvatarId)
            : 0;

        if (curPosition < 0) return;

        if (curPosition === 0 && !next && AudioManager.currentMediaNodeText) {
            StoreManager.addParameters({
                textMode: true,
                currentAvatarId: null
            })

            console.log("Text mode");
            return;
        }

        if (curPosition === 0 && !next) {
            return;
        }


        if (next) {

            if (this.props.parameters.textMode) {
                StoreManager.addParameters({
                    textMode: false,
                    currentAvatarId: null
                })
                console.log("Exit text mode, use def avatar");

                return;
            }

            if (curPosition + 1 >= avatarList.length) {
                return;
            }

            StoreManager.addParameters({
                currentAvatarId: avatarList[curPosition + 1].mediaId
            })


        } else {
            StoreManager.addParameters({
                currentAvatarId: curPosition === 1 ? null : avatarList[curPosition - 1].mediaId
            })

            console.log("Previous avatar");
        }

    }

    async onTestClick() {

        //
        // const imageData = await BarcodeDecoder.imageDataFromBase64(testImg);
        //
        // console.time("decoder");
        // this.decoder = new BarcodeDecoder(imageData);
        // const result = this.decoder.decode();
        // console.timeEnd("decoder");
        //
        // this.setState({
        //     testImg: this.decoder.getMonoBase64ImgData()
        // });
        // console.log("DECODER FINISH - ", result);
    }

    onTestImgClick(e) {
        const x = e.nativeEvent.offsetX;
        const y = e.nativeEvent.offsetY-1;
        console.log(x+':'+y, this.decoder.bWImageData[y * this.decoder.width + x]);
    }

    render() {
        // IMPORTANT: Don't remove mediaProgress initialization!
        // eslint-disable-next-line no-unused-vars
        const {object, selectedLanguage, mediaProgress: {duration}} = this.props;
        const parentObject = object && object.parentObject ? new ObjectData(object.parentObject) : null;

        const text = AudioManager.currentMediaNodeText;

        return (
            <React.Fragment>
                <Swipeable
                    onSwipedLeft={() => this.onSwipe(true)}
                    onSwipedRight={() => this.onSwipe(false)}>

                    <div id="DescriptionContainer">

                        {
                            this.props.parameters.textMode && text
                                ? this.renderTextPreview(text)
                                : this.renderAvatarElement()
                        }


                        {
                            !this.props.parameters.textMode &&
                                <div id={object && object.avatarImage ? "DescriptionText" : "DescriptionTextOnly"}>
                                    {object ? object.description(selectedLanguage) || ' ' : ' '}

                                    {
                                        parentObject &&
                                        <small className='lightText'>
                                            <br/>
                                            {parentObject.description(selectedLanguage) || " "}
                                        </small>
                                    }
                                </div>
                        }

                        {
                            this.renderSliderControl()
                        }

                    </div>
                </Swipeable>
            </React.Fragment>
        );
    }

}


const mapStateToProps = ({object, selectedLanguage, mediaProgress, isPlaying, parameters}) => ({object, selectedLanguage, mediaProgress, isPlaying, parameters});
export default connect(mapStateToProps)(DescriptionBlock);